/* eslint-disable no-param-reassign */
import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import convertDistance from 'geolib/es/convertDistance'
import getDistance from 'geolib/es/getDistance'

import {
  fetchCarepointFacilities,
  fetchPractitionersAndCoordinates,
  fetchPractitionersByNpi,
} from './thunks.async'

const providersAdapter = createEntityAdapter()

const initialState = providersAdapter.getInitialState({
  providers: {
    items: [] as any[],
    status: 'empty',
  },
  practitioners: {
    items: [] as any[],
    status: 'empty',
  },
  provider: {
    item: {} as any,
    status: 'empty',
  },
})

export const providersSlice = createSlice({
  name: 'providers',
  initialState,
  reducers: {
    reset: () => initialState,
    loadProvider: state => {
      state.provider.status = 'loading'
    },
    setProvider: (state, action: PayloadAction<any>) => {
      state.provider.item = action.payload
      state.provider.status = 'loaded'
    },
    clearProvider: state => {
      state.provider.item = {}
      state.provider.status = 'empty'
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchCarepointFacilities.pending, state => {
        state.providers.status = 'loading'
      })
      .addCase(fetchCarepointFacilities.fulfilled, (state, action) => {
        state.providers.status = 'loaded'
        state.providers.items = action.payload
        state.practitioners.status = 'empty'
        state.practitioners.items = []
      })
      .addCase(fetchCarepointFacilities.rejected, state => {
        state.providers.status = 'loaded'
        state.providers.items = []
      })
      .addCase(fetchPractitionersAndCoordinates.pending, state => {
        state.practitioners.status = 'loading'
      })
      .addCase(fetchPractitionersAndCoordinates.fulfilled, (state, action) => {
        const [coordinates, data] = action.payload
        state.practitioners.status = 'loaded'
        state.practitioners.items = data.map((item: any) => {
          return {
            ...item,
            distance: convertDistance(
              getDistance(coordinates, { lat: item.lat, lon: item.long }),
              'mi'
            ).toFixed(2),
          }
        })
        state.providers.status = 'empty'
        state.providers.items = []
      })
      .addCase(fetchPractitionersAndCoordinates.rejected, state => {
        state.practitioners.status = 'loaded'
        state.practitioners.items = []
      })
      .addCase(fetchPractitionersByNpi.pending, state => {
        state.practitioners.status = 'loading'
      })
      .addCase(fetchPractitionersByNpi.fulfilled, (state, action) => {
        state.practitioners.status = 'loaded'
        state.practitioners.items = action.payload
        state.providers.status = 'empty'
        state.providers.items = []
      })
      .addCase(fetchPractitionersByNpi.rejected, state => {
        state.practitioners.status = 'loaded'
        state.practitioners.items = []
      })
  },
})
